import React, { useCallback, useRef } from "react"
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api"
import { CircularProgress } from "@mui/material"
import { MapPin } from "lucide-mui"

type LocationMapProps = {
  center: { lat: number; lng: number }
  onCoordinatesChange: (lat: number, lng: number) => void
  apiKey: string
}

const containerStyle = { width: "100%", height: "250px" }

const LocationMap: React.FC<LocationMapProps> = ({ center, onCoordinatesChange, apiKey }) => {
  const mapRef = useRef<google.maps.Map | null>(null)

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  })

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map
  }, [])

  const onIdle = useCallback(() => {
    const map = mapRef.current
    if (!map) return
    const c = map.getCenter()
    if (!c) return
    onCoordinatesChange(c.lat(), c.lng())
  }, [onCoordinatesChange])

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center rounded-lg bg-gray-100" style={{ height: 250 }}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <div className="relative rounded-lg overflow-hidden">
      <div
        className="pointer-events-none absolute z-10"
        style={{ top: "50%", left: "50%", transform: "translate(-50%, -100%)" }}
      >
        <MapPin sx={{ fontSize: 36, color: "#E53935" }} />
      </div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        onLoad={onLoad}
        onIdle={onIdle}
        options={{ disableDefaultUI: false, zoomControl: true, streetViewControl: false, mapTypeControl: false }}
      />
    </div>
  )
}

export default LocationMap
